import React from "react";
import { useI18n } from "../lib/i18n";

// Logo optimisé (437×160 WebP ~31 Ko) servi en statique — l'original de 224 Ko ralentissait chaque page
import logoBriouse from "../assets/logo-domaine-briouse.webp";

const LOGO_URL = logoBriouse;

export default function LanguageSwitcher({ className = "" }) {
  const { locale, setLocale } = useI18n();
  return (
    <div className={`flex items-center gap-2 text-xs tracking-widest ${className}`} data-testid="language-switcher">
      <button
        type="button"
        onClick={() => setLocale("fr")}
        aria-pressed={locale === "fr"}
        data-testid="language-fr-button"
        className={`uppercase transition-colors ${
          locale === "fr" ? "text-domaine underline underline-offset-4" : "text-ardoise/60 hover:text-domaine"
        }`}
      >
        FR
      </button>
      <span className="text-pierre">/</span>
      <button
        type="button"
        onClick={() => setLocale("en")}
        aria-pressed={locale === "en"}
        data-testid="language-en-button"
        className={`uppercase transition-colors ${
          locale === "en" ? "text-domaine underline underline-offset-4" : "text-ardoise/60 hover:text-domaine"
        }`}
      >
        EN
      </button>
    </div>
  );
}

export { LOGO_URL };
